import React from "react";

// Simple chain glyph badge using the first letters + brand color
export default function ChainIcon({ chain, size = 40 }) {
  const label = chain.symbol.slice(0, chain.symbol.length > 3 ? 3 : chain.symbol.length);
  return (
    <div
      className="flex items-center justify-center rounded-full font-rajdhani font-bold"
      style={{
        width: size,
        height: size,
        background: `${chain.color}1A`,
        border: `1.5px solid ${chain.color}66`,
        color: chain.color,
        fontSize: size * 0.32,
        boxShadow: `0 0 14px ${chain.color}22`,
      }}
    >
      {label}
    </div>
  );
}
